export enum ButtonType {
  Button = 'button',
  Menu = 'menu',
  Reset = 'reset',
  Submit = 'submit',
}
